// extracted by mini-css-extract-plugin
export var container = "Quotations-module--container--f7d3d";
export var fadeInAnimation = "Quotations-module--fadeInAnimation--27283";
export var icons = "Quotations-module--icons--1c75f";
export var layout = "Quotations-module--layout--95152";
export var title = "Quotations-module--title--7b4a2";